import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import InputText from "../../../../common/components/input-text/input-text";
import Cx from "classnames";
import Select from "react-select";

const authTypeOptions = [
  { label: "TOKEN", value: "TOKEN" },
  { label: "BASIC", value: "BASIC" }
];

class AddSapMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: this.props.editData ? this.props.editData.name : "",
        interface_id: this.props.editData ? this.props.editData.interface_id : "",
        url: this.props.editData ? this.props.editData.url : "",
        username: this.props.editData ? this.props.editData.username : "",
        password: this.props.editData ? this.props.editData.password : "",
        auth_type: this.props.editData ?  this.props.editData.auth_type : "",
        bearer_token: this.props.editData
          ? this.props.editData.bearer_token
          : "",
        client: this.props.editData ? this.props.editData.client : "",
        integration_id: this.props.editData
          ? this.props.editData.integration_id
          : undefined,
        is_payload: this.props.editData
          ? this.props.editData.is_payload
          : false,
        company_id: this.props.editData
          ? this.props.editData.company_id
          : this.props.companyId,
      },
    };
  }

  componentDidMount() {
    setItemToSessionStorage("previousSapData", this.props.editData);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };


  onChangeSapInterFaceName = (e) => {
    let { data } = this.state;
    data.name = e.interface_name;
    data.interface_id = e.interface_id;
    this.setState({ data });
  };

  onChangeAuthType = (selectedOption) => {
     let { data } = this.state;
     data.auth_type = selectedOption.value;
     this.setState({ data });
  };

  render() {
    const { data } = this.state;

    const disable = !(
      data["name"] &&
      data["url"] &&
      data["username"] &&
      data["password"] && 
      data["auth_type"]
    );

    let optionSapInterFaceName = [];

    if (this.props.sapInterFaceData) {
      optionSapInterFaceName = this.props.sapInterFaceData.map((item) => ({
        value: item.id,
        label: item.interface_name,
        interface_name: item.interface_name,
        interface_id: item.id,
      }));
    }

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{ minHeight: "600px" }}>
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Sap Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px" }}
            >

              {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"name"}
                  label="Name"
                  changeHandler={(value) => this.onChangeHandler(value, "name")}
                  value={data["name"]}
                  required={true}
                />
              </div> */}

              <div style={{ display: "flex", flexDirection: "column" }}>
                  <div className="label">Name <span className="error-color">*</span></div>
                      <Select
                        className={Cx("selectpack")}
                        options={optionSapInterFaceName}
                        value={optionSapInterFaceName.find(
                          (val) => val.value == data.interface_id
                        )}
                        onChange={(e) => this.onChangeSapInterFaceName(e)}
                      />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"url"}
                  label="Url"
                  changeHandler={(value) => this.onChangeHandler(value, "url")}
                  value={data["url"]}
                  required={true}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"username"}
                  label="User Name"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "username")
                  }
                  value={data["username"]}
                  required={true}
                />
              </div>
            </div>

            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"password"}
                  label="Password"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "password")
                  }
                  value={data["password"]}
                  required={true}
                />
              </div>
              <div>
                <InputText
                  placeholder=""
                  id={"bearer_token"}
                  label="Bear Token"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "bearer_token")
                  }
                  value={data["bearer_token"]}
                  // required={true}
                />
              </div>
              <div>
                <InputText
                  placeholder=""
                  id={"client"}
                  label="Sap Client"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "client")
                  }
                  value={data["client"]}
                />
              </div>
            </div>
            <div
              className="details-section"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                  <div className="label">Auth Type <span className="error-color">*</span></div>
                      <Select
                        className={Cx("selectpack")}
                        options={authTypeOptions}
                        value={authTypeOptions.find(
                           (val) => val.value == data.auth_type
                        )}
                        onChange={this.onChangeAuthType}
                      />
              </div>
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={!!data.is_payload}
                  onChange={(e) =>
                    this.onChangeHandler(e.target.checked, "is_payload")
                  }
                />
                <span className="checkmark"></span>
                <span className="checkbox-label">Payload</span>
              </label>
            </div>

            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button value={"Save"} click={this.onSave} disabled={disable} />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddSapMaster;
